import * as React from 'react';
import Table from 'react-bootstrap/Table';
import Stack from '@mui/material/Stack';
import Button from '@mui/material/Button';
import EditOutlinedIcon from '@mui/icons-material/EditOutlined';
import VisibilityOutlinedIcon from '@mui/icons-material/VisibilityOutlined';
import DeleteOutlineOutlinedIcon from '@mui/icons-material/DeleteOutlineOutlined';
import PersonAddOutlinedIcon from '@mui/icons-material/PersonAddOutlined';
import Pagination from '@mui/material/Pagination';
import { Link, NavLink } from 'react-router-dom';
import Col from 'react-bootstrap/Col';
import Form from 'react-bootstrap/Form';
import Row from 'react-bootstrap/Row';
import { postRequest } from '../../lib/api';
import { AuthContext } from '../../authContext/context';
import { useContext, useEffect, useState, useRef } from 'react';
import CircularProgress from '@mui/material/CircularProgress';
import Swal from 'sweetalert2';
import { useDispatch } from 'react-redux';
//import { deleteProduct as deleteProductFromStore } from '../../redux/slices/productSlice';
import BreadcrumbsWrapper from '../../components/breadcrumbs'


// Redux imports (optional, if you want to store in redux)
// import { useDispatch } from 'react-redux';
// import { setBranches } from '../../redux/slices/branchSlice';

export default function Products() {
  const [productList, setProductList] = useState([]);
  const [loading, setLoading] = useState(true);
  const [page, setPage] = useState(1);
  const [totalPages, setTotalPages] = useState(1);
  const [totalDocs, setTotalDocs] = useState(0);
  const [searchName, setSearchName] = useState('');
  const authCtx = useContext(AuthContext);

  // Debounce ref
  const debounceRef = useRef();
  const dispatch = useDispatch();

  // Fetch branches API
 const fetchProducts = async (searchNameVal, pageVal = page) => {
  setLoading(true);
  try 
    {
    const payload = {
      page: pageVal,
      limit: 10,
      search: searchNameVal,
    };

    const response = await postRequest('private/productList', payload, authCtx.token);
    console.log(response , 'response@123')
    if (response?.status === 200 && response?.data) {
      setProductList(response.data.docs || []);
      setTotalPages(response.data.totalPages || 1);
      setTotalDocs(response.data.totalDocs || 0);
    } else {
      setProductList([]);
      setTotalPages(1);
      setTotalDocs(0);
    }
  } catch (err) {
    setProductList([]);
    setTotalPages(1);
    setTotalDocs(0);
  }
  setLoading(false);
};

  // Fetch on mount and when page changes
  useEffect(() => {
    fetchProducts(searchName, page);
    // eslint-disable-next-line
  }, [page, authCtx.token]);

  // Debounced search on name or postcode change
  useEffect(() => {
    setPage(1); // Reset to first page on search
    if (debounceRef.current) clearTimeout(debounceRef.current);
    debounceRef.current = setTimeout(() => {
      fetchProducts(searchName, 1);
    }, 400);
    // eslint-disable-next-line
  }, [searchName]);

  const handlePageChange = (event, value) => {
    setPage(value);
  };


const handleDeleteBranch = async (id) => {
  const result = await Swal.fire({
    title: 'Are you sure?',
    text: 'You will not be able to recover this product!',
    icon: 'warning',
    showCancelButton: true,
    confirmButtonColor: '#bb0000',
    cancelButtonColor: '#aaa',
    confirmButtonText: 'Yes, delete it!',
  });

  if (result.isConfirmed) {
    try {
      const response = await postRequest(`private/deleteProduct/${id}`, {}, authCtx.token);
      if (response?.status === 200) {
        Swal.fire('Deleted!', 'Product has been deleted.', 'success');

        // ✅ After deletion, fetch the current page again
        const payload = {
          page,
          limit: 5,
          search: searchName,
        };
        const listResponse = await postRequest('private/productList', payload, authCtx.token);

        const docs = listResponse?.data?.docs || [];
        const totalPagesAfterDelete = listResponse?.data?.totalPages || 1;

        // ✅ If current page has no items, and we're not on the first page, go to previous page
        if (docs.length === 0 && page > 1) {
          setPage(prev => prev - 1);
        } else {
          setProductList(docs);
          setTotalPages(totalPagesAfterDelete);
        }
      } else {
        Swal.fire('Failed!', response?.message || 'Something went wrong.', 'error');
      }
    } catch (err) {
      Swal.fire('Error!', err?.message || 'Something went wrong.', 'error');
    }
  }
};



  return (
    <>

      <div className='page-header pb-3'>
  
        <h1 className='mt-0 mb-0'>Products</h1>
        <div className='header-right-btn'>
          <Stack spacing={2} direction="row">
            <Button variant="outlined" className='red-outline-btn text-capitalize'>
              <NavLink to="/products/create" className="red-link-text">
                <PersonAddOutlinedIcon /> &nbsp; Add New Product
              </NavLink>
            </Button>
          </Stack>
        </div>
      </div>
          <BreadcrumbsWrapper
                                        items={[
                                          { label: 'Dashboard', path: '/dashboard' },
                                          { label: 'Products', path: '' },
                                        
                                         
                                        ]}
                                      />
                                <br></br>
    
      <div className='page-top-formview mb-3'>
        <Form>
          <Row className="mb-3">
            <Form.Group as={Col} controlId="searchUsername">
              <Form.Label>Product Title</Form.Label>
              <Form.Control
                type="text"
                placeholder="Search with product title"
                value={searchName}
                onChange={e => {
                  setSearchName(e.target.value);
                  setPage(1);
                }}
              />
            </Form.Group>
          </Row>
        </Form>
      </div>

      <div>
        <Table striped responsive bordered>
          <thead>
            <tr>
             
              <th>Product Name</th>
              <th>Action</th>
            </tr>
          </thead>
          <tbody>
            {loading ? (
              <tr>
                <td colSpan={4} style={{ textAlign: 'center' }}>
                  <CircularProgress size={28} />
                </td>
              </tr>
            ) : productList.length === 0 ? (
              <tr>
                <td colSpan={4} style={{ textAlign: 'center' }}>
                  No products found.
                </td>
              </tr>
            ) : (
              productList.map((product) => (
                <tr key={product._id}>
                  <th>{product?.title}</th>
                  <td>
                    
                    <span
                      className='red-link-text cursor-pointer w-18'
                      title="Edit"
                      style={{ marginRight: 8 }}
                    >
                      <NavLink to={`/products/edit/${product._id}`} className="red-link-text">
                        <EditOutlinedIcon />
                      </NavLink>
                    </span>
                 <span
                className='red-link-text cursor-pointer w-18'
                title="Delete"
                onClick={() => handleDeleteBranch(product._id)}
              >
                <DeleteOutlineOutlinedIcon />
              </span>

                  </td>
                </tr>
              ))
            )}
          </tbody>
        </Table>
        {/* Pagination */}
      {productList.length > 0 && (
  <>
    <div style={{ display: 'flex', justifyContent: 'flex-start', marginTop: 8, marginBottom: 8 }}>
      <span className="text-muted small">
        Showing {((page - 1) * 10) + 1}-{Math.min(page * 10, totalDocs)} of {totalDocs} products
      </span>
    </div>
    <div style={{ display: 'flex', justifyContent: 'center', marginTop: 8 }}>
      <Pagination
        count={totalPages}
        page={page}
        onChange={handlePageChange}
        color="primary"
        shape="rounded"
        size="medium"
        sx={{
          '& .Mui-selected': {
                    background: 'linear-gradient(135deg, #764ba2 0%, #667eea 100%) !important',
                    color: '#fff !important',
                  },
                  '& .MuiPaginationItem-root': {
                    color: 'var(--bs-red-color)',
                    borderColor: 'var(--bs-red-color)',
                  },
        }}
      />
    </div>
  </>
)}

      </div>
    </>
  );
}